import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  addSemesterApi,
  addStudentApi,
  assignTrip, bulkUpdate, canclledStudentTravel, editSemesterApi, removeSemesterApi,
  editStudentApi,
  getAssignTrip, getSemesterApi,
  getStudentApi,
  getStudentsApi, getStudentTripApi,
  removeStudentApi
} from '../api/students';
import {getTravelsApi} from '../api/tripline';
import * as XLSX from 'xlsx';
import * as _ from "lodash";
import {XlsxToJsonService} from '../api/xlsx-to-json-service';
import swal from "sweetalert2";
import {uplodeImage} from '../api/util';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {

  constructor(private _fb: FormBuilder) {
  }

  data: FormGroup;
  semster: FormGroup;
  assignTripData = [];
  students = [];
  semsters = [];
  editMode = false;
  travel={};
  title=""
  rowSelected = {};
  selectedTrip = [];
  trips = [];
  studentTrip=[]
  selectedTravelData={}
  convertData=[]
  p: number = 1;
  deletedSemsters = []
  private xlsxToJsonService: XlsxToJsonService = new XlsxToJsonService();
  profileImg="assets/images/profile-square.jpg"
  imageUplode=false
  loader=true
  ngOnInit() {

    this.data = this._fb.group({
      name: ['', Validators.required],
      sis_code: ['', Validators.required],
      password: ['', Validators.required],
      phone: ['', Validators.required],
      profile_photo: [''],
      student_id: ['', Validators.required],
      semester: ['', Validators.required]
    });
    this.semster = this._fb.group({
      semster: this._fb.array([])

    });
    this.getStudents();
    this.getTravels();
    this.getSemster();
  }



  async getStudentTrip(id,title){
    this.title=title
    let result=await getStudentTripApi(id)
    if(result){

      this.studentTrip=result.data.data


    }
  }

  changeImage(input) {
    console.log('sss', input);
    let reader;
    this.imageUplode=true

    if (input.target.files) {
      reader = new FileReader();

      reader.onload = (e) => {
        console.log(e.target.result);

        this.data.get('profile_photo').setValue(e.target.result);
        this.profileImg=e.target.result
        // preview.setAttribute('src', e.target.result);
      }

      reader.readAsDataURL(input.target.files[0]);
    }
  }
  async getSemster() {
      const semester = [];
    const result = await getSemesterApi();

    if (result) {
      const data = result.data.data;
      this.semsters = data
      data.map(row => {

        semester.push(this.initItemRows(row.name, row.start, row.end, row._id));
      });


      this.semster = this._fb.group({
        semster: this._fb.array(semester)

      });
    }

  }

  deleteSemster(index: number) {
    const control = <FormArray>this.semster.controls['semster'];
    this.deletedSemsters.push(this.semster.value.semster[index])
    control.removeAt(index);
  }
  addSemster() {
    const control = <FormArray>this.semster.controls['semster'];

    control.push(this.initItemRows());
  }

  initItemRows(name= '', start= '', end= '', _id= null) {


    return this._fb.group({
      name: [name, Validators.required],
      start: [start, Validators.required],
      end: [end, Validators.required],
      _id: [_id],

    });
    // @ts-ignore


  }
  async getStudents() {
    this.data = this._fb.group({
      name: ['', Validators.required],
      sis_code: ['', Validators.required],
      password: ['', Validators.required],
      phone: ['', Validators.required],
      profile_photo: [''],
      student_id: ['', Validators.required],
      semester: ['', Validators.required],
    });
    const result = await getStudentsApi();
    this.profileImg="assets/images/profile-square.jpg"

    this.editMode = false;
    this.loader=true
    if (result) {
      this.students = [];
      this.students = result.data.data;
      this.data = this._fb.group({
        name: ['', Validators.required],
        sis_code: ['', Validators.required],
        password: ['', Validators.required],
        phone: ['', Validators.required],
        profile_photo: [''],
        student_id: ['', Validators.required],
        semester: ['', Validators.required],
      });
      this.loader=false


    }

  }


  closeAssignTravelModal(){
    document.getElementById('mytripModal').click()
  }

  openAssignTravelModal(){
   this.getStudentTrip(this.rowSelected['_id'],'الرحلات المجدولة')
    document.getElementById('myTripOpenModal').click()
  }

  selectedTravel(travel){
    this.selectedTravelData=travel
    this.closeAssignTravelModal()
  }
  async removeAssignTravel(id){
    const result=await canclledStudentTravel(id)
    if (result) {
// this.openAssignTravelModal()
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }
  }


  async getStudent(id) {
    const result = await getStudentApi(id);
    this.editMode = true;
    console.log(this.editMode);
    if (result) {

      const student = result.data.data;
      this.rowSelected=student

      this.data = this._fb.group({
        name: [student.name, Validators.required],
        sis_code: [student.sis_code, Validators.required],
        password: [student.password, Validators.required],
        phone: [student.phone.replace('+962',''), Validators.required],
        profile_photo: [student.profile_photo],
        student_id: [student.student_id, Validators.required],
        semester: [student.semester, Validators.required],
      });
      this.profileImg=student.profile_photo

    }

  }

  async getAssignStudent(id) {

    const result = await getAssignTrip(id);

    if (result) {
      const data = result.data.data;
      data.map(row => {
        this.assignTripData.push(row._id);
      });
    }

  }

  selectedRow(row) {
    this.rowSelected = {};
    this.rowSelected = row;

    this.getAssignStudent(row['_id']);
  }
  changeEditMode() {
    this.editMode = false;
    this.data = this._fb.group({
      name: ['', Validators.required],
      sis_code: ['', Validators.required],
      password: ['', Validators.required],
      phone: ['', Validators.required],
      profile_photo: [''],
      student_id: ['', Validators.required],
      semester: ['', Validators.required],
    });
    this.profileImg="assets/images/profile-square.jpg"

  }

  async getTravels() {
    const result = await getTravelsApi();

    if (result) {
      this.trips = [];
      this.trips = result.data.data;



    }

  }


  assignToTrip(trip, checked) {

    if (this.selectedTrip.includes(trip) || checked) {
      this.selectedTrip = this.selectedTrip.filter(function(value, index, arr) {

        // tslint:disable-next-line:triple-equals
        return value != trip;

      });
    } else {
      this.selectedTrip.push(trip);
    }

    console.log(this.selectedTrip);
  }


  async removeStudent(id) {
    const result = await removeStudentApi(id);

    if (result) {

      const student = result.data.data;
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }

  }
  async edit() {
    const data = this.data.value;


    if (this.imageUplode) {
      const img = data.profile_photo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.profile_photo = uplode.data;
      }
    }
    data.phone = '+962'+data.phone
    const result = await editStudentApi(data, this.rowSelected['_id']);

    if (result) {
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }

  async activeAccount(active, id) {



    const result = await editStudentApi(  {active: active}, id);

    if (result) {
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }
  async deleteAccount(id) {



    const result = await editStudentApi(  {disabled: true}, id);

    if (result) {
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }


  async addSemester(data) {
    const result = await addSemesterApi(data);
    if (result) {

      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      return true;
    } else {
      return false;
    }
  }
  async editSemester(data, id) {
    const result = await editSemesterApi(data, id);
    if (result) {
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      return true;

    } else {

        swal(
          'حصل خطأ، يرجى المحاولة مرة أخرى',
          '',

          'error'
        )
      return false;

    }
  }
  async removeSemester(id:string) {
    const result = await removeSemesterApi(id);
    if (result) {

      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      return true;
    } else {
      return false;
    }
  }

  async saveSemester() {

    if(this.deletedSemsters.length) {
      for (let obj of this.deletedSemsters) {
        if (obj._id) {
          await this.removeSemester(obj._id);
        }
      }
      this.deletedSemsters = [];
    }

    const data = this.semster.value.semster;


    for (let obj of data) {

      if (obj._id) {
        // delete obj._id;
        const result = await this.editSemester(obj, obj._id);

      } else {
        const result = await this.addSemester(obj);
      }

    }

    this.getSemster()

    console.log('deleted Semsters: ', this.deletedSemsters)

  }



  async add() {
    const data = this.data.value;


    if (this.imageUplode) {
      const img = data.profile_photo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.profile_photo = uplode.data;
      }
    }
    data.phone = '+962'+data.phone
    const result = await addStudentApi(data);

    console.log(result)
    if (!result['err']) {
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        result['err'].response.data,
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }

  async AsignTrip() {
    this.selectedTrip=_.uniq(this.selectedTrip)
    const data = {trips: this.selectedTrip, student_id: this.rowSelected['_id']};
const result = await assignTrip(data);
    if (result) {
      this.getStudents();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }
  }


  async handleFile(event) {
    let file = event.target.files[0];

    this.convertData = []

    this.xlsxToJsonService.processFileToJson({}, file).subscribe(async data => {

      // console.log(this.convertData)
      let datax = JSON.parse(JSON.stringify(data['sheets'].Sheet1));

      datax.map(row => {
        this.convertData.push({
          student_id: row.student_id,
          sis_code: row.sis_code

        })
      })

      console.log(this.convertData)
      let result = await bulkUpdate(this.convertData)

      if (result) {
        swal(
          'تم انتهاء  العملية بنجاح',
          '',

          'success'
        )
        this.getStudents()
      }else {
        swal(
          'حصل خطأ، يرجى المحاولة مرة أخرى',
          '',

          'error'
        )
      }
    })




  }


  openFile() {
    document.getElementById('file').click();
  }

  excelFile() {
    document.getElementById("file-excel").click()
  }
  @ViewChild("search")
  public searchElementRef: ElementRef;

  removeSearch() {
    this.searchElementRef.nativeElement.value=""
  }
}
